import * as React from "react";
import { Box, Table, TableBody, TableCell, TableSortLabel, TableContainer, TableHead, TablePagination, TableRow, Divider, } from "@material-ui/core";
import { TableRowsSkeleton } from "frontend/src/ui/table-skeleton";
import { Tracks } from "./tracks";
import { Skeleton } from "@material-ui/lab";
var headCells = [
    { id: "title", label: "Название", isSortable: true },
    { id: "artist", label: "Исполнитель", isSortable: true },
    { id: "genres", label: "Жанры", isSortable: false },
    { id: "formatted", label: "Время", isSortable: true },
    { id: "ISRC", label: "ISRC", isSortable: true },
    { id: "is_normalized", label: "Нормализован?", isSortable: true },
    { id: "is_approved", label: "Одобрен?", isSortable: true },
];
export var TracksSearchResultTable = React.memo(function (_a) {
    var sorting = _a.sorting, pagination = _a.pagination, tracks = _a.tracks;
    var node = (React.createElement(TablePagination, { component: "div", count: tracks.total, page: pagination.page, onPageChange: pagination.onChangePage, rowsPerPage: pagination.rowsPerPage, onRowsPerPageChange: pagination.onChangeRowsPerPage, labelRowsPerPage: "Показывать треков" }));
    return (React.createElement(Box, null,
        tracks.entries ? (node) : (React.createElement(Box, { display: "flex", justifyContent: "flex-end" },
            React.createElement(Skeleton, null, node))),
        React.createElement(Divider, null),
        React.createElement(TableContainer, null,
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null),
                        headCells.map(function (headCell) { return (React.createElement(TableCell, { key: headCell.id, sortDirection: sorting.sortBy === headCell.id ? sorting.orderBy : false }, headCell.isSortable ? (React.createElement(TableSortLabel, { active: sorting.sortBy === headCell.id, direction: sorting.sortBy === headCell.id
                                ? sorting.orderBy
                                : "asc", onClick: function () { return sorting.onChange(headCell.id); } }, headCell.label)) : (headCell.label))); }),
                        React.createElement(TableCell, null))),
                React.createElement(TableBody, null, tracks.entries ? (React.createElement(Tracks, { tracks: tracks.entries, onTrackToggle: tracks.onToggle, onPause: tracks.onPause, onPlay: tracks.onPlay, onResume: tracks.onResume })) : (React.createElement(TableRowsSkeleton, { rows: pagination.rowsPerPage, columns: 8 })))))));
});
